import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

export const ErrorSubjects = {
	themeAPI: 'themeAPI',
	remoteThemeStorage: 'remoteThemeStorage',
	useThemingState: 'useThemingState',
	useGlobalColorMode: 'useGlobalColorMode',
};

export const ErrorSubjectIds = {
	getSavedTheme: 'getSavedTheme',
	apolloMutationErrors: 'apolloMutationErrors',
	saveThemeRemote: 'saveThemeRemote',
	setColorMode: 'setColorMode',
	fetchGlobalColorMode: 'fetchGlobalColorMode',
	apolloQueryErrors: 'apolloQueryErrors',
};

export const reportThemingError = async (
	subject: any,
	subjectId: any,
	attributes: any,
): Promise<void> => {
	const client = await getAnalyticsWebClient();
	client.sendUIEvent({
		source: 'theming',
		action: 'error',
		actionSubject: subject,
		actionSubjectId: subjectId,
		attributes,
	});
};
